module.exports = __webpack_public_path__ + "static/grafika4@2x-d6f7a21529a071db94b83e681977ac5e.png";